import { visserApi } from "./visserApi";
import { convertModelToFormData } from "./helpers";
const getAllDocumentation = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`Documentation/GetAll?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getDocumentationById = (documentationId) => {
    return visserApi.get(`Documentation/GetDocumentationById/${documentationId}`);
};
const createDocumentation = async (documentation) => {
    return visserApi.post('Documentation/Create', documentation);
};
const updateDocumentation = async (documentationId, updatedDocumentation) => {
    return await visserApi.put(`Documentation/Update/${documentationId}`, updatedDocumentation);
};
const deleteDocumentationById = async (id) => {
    return await visserApi.delete(`Documentation/DeleteDocumentation/${id}`);
};
const addAttachmentByDocumentationId = (fileUploaded) => {
    const formData = convertModelToFormData(fileUploaded);
    return visserApi.postForm('Documentation/UploadDocumentationDocument', formData);
};
const getAllAttachmentsByDocumentationId = async (documentationId) => {
    return await visserApi.get(`Documentation/GetAllDocumentationDocuments/${documentationId}`);
};
const deleteDocumentationAttachment = (attachmentId) => {
    return visserApi.delete(`Documentation/DeleteDocumentationDocument/${attachmentId}`);
};
const getDocumentationDocumentById = (documentationDocument) => {
    return visserApi.post('Documentation/GetDocumentationDocument', documentationDocument);
};
const DocumentationApi = {
    getAllDocumentation,
    getDocumentationById,
    createDocumentation,
    updateDocumentation,
    deleteDocumentationById,
    addAttachmentByDocumentationId,
    getAllAttachmentsByDocumentationId,
    deleteDocumentationAttachment,
    getDocumentationDocumentById
};
export default DocumentationApi;
